/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsClearingV1SweepTargetStatsEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_CLEARING_V1_SWEEP_TARGET_STATS_EVENT_ENTITY_NAME = 'ixc.sweeps.clearing.v1.SweepTargetStatsEvent';
export const ixcSweepsClearingV1SweepTargetStatsEventEntity = new schema.Entity<IxcSweepsClearingV1SweepTargetStatsEvent>(IXC_SWEEPS_CLEARING_V1_SWEEP_TARGET_STATS_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcSweepsClearingV1SweepTargetStatsEvent) => `${entity.metadata?.eventId}` });

